module.exports = __webpack_public_path__ + "img/page-bg-km.39463c7b.png";